import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OnePageLayout from "../../components/layout/OnePageLayout";
import {
  Btns,
  ButtonL,
  ButtonM,
  Content,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import bg from "../../styles/images/signup_bg.png";
import cat from "../../styles/images/cat.png";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/slices/authSlice";
import { Modal } from "../../components/modal/Modal";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  const result = location.state !== null ? location.state.result : "";
  const reason = location.state !== null ? location.state.reason : "";
  const [openModal, setOpenModal] = useState(false);
  const [openToLoginModal, setOpenToLoginModal] = useState(false);

  const urls = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (result === false) {
      console.log("false");
      if (reason == "email") {
        setOpenToLoginModal(true);
      } else {
        setOpenModal(true);
      }
    }
  }, []);
  return (
    <OnlyHeaderLayout title="MU Point 회원가입">
      {openModal && (
        <Modal setOpenModal={setOpenModal}>
          <p>본인인증을 재시도 해주세요.</p>
        </Modal>
      )}
      {openToLoginModal && (
        <Modal
          setOpenModal={setOpenToLoginModal}
          callbackFunc={() => {
            navigate("/login");
          }}
        >
          <p>이미 가입된 계정입니다.</p>
        </Modal>
      )}
      <Section>
        <TextDiv>
          <h3>간편하게 가입하고 다양한 혜택을 누리세요!</h3>
        </TextDiv>
        <Content>
          <ImgWrap>
            <img src={bg} alt="" />

            <ButtonM
              onClick={() => {
                dispatch(authActions.resetSignUpInfo());
                // dispatch(authActions.checkPagePathname(path));
                sessionStorage.setItem(
                  "page",
                  JSON.stringify({ path: path, option: "" })
                );

                window.open(`${urls}/danal/ready`, "_self", "fullscreen=yes");
              }}
            >
              휴대폰 가입
            </ButtonM>
          </ImgWrap>
        </Content>
        <DescTextDiv>
          <p>MU Point 회원가입은 만 14세 이상만 가입 가능합니다.</p>
        </DescTextDiv>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default SignUp;

const ImgWrap = styled.div`
  margin-top: 6.8rem;
  text-align: center;
  position: relative;

  button {
    bottom: 1rem;
    margin: auto;
    left: 0;
    right: 0;
    position: absolute;

    &::after {
      display: block;
      content: "";
      background-image: url(${cat});
      background-size: cover;
      background-position: center;
      width: 8rem;
      height: 6.4rem;
      position: absolute;
      top: -3.2rem;
      left: 2.3rem;
    }
  }
`;

const DescTextDiv = styled(TextDiv)`
  /* margin-top: 5.6rem; */
  letter-spacing: -0.42px;
  padding-bottom: 3rem;
`;
